import React from "react";

interface ValidationListProps {
  data: any[];
  title: string;
  renderElement?: (item: any) => React.ReactNode;
}

const ValidationList: React.FC<ValidationListProps> = ({
  data,
  title,
  renderElement,
}) => {
  return (
    <div className="text-text-500 text-base mb-[12px]">
      <div className="text-base font-semibold">{title}</div>
      <div className="py-[8px]">
        <ul className="ml-4  list-disc pl-5">
          {data.map((item, index) => (
            <li key={index} className="font-medium text-[12px] mb-[2px]">
              {renderElement ? renderElement(item) : item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ValidationList;
